module.exports = __webpack_public_path__ + "img/editor_preview-5.0f40edd.webp";